<template>
  <v-card outlined>
    <v-card-text>
      <tabs @tab-changed="onTabChange($event)"></tabs>
      <div v-for="parashah of parashahs" :key="parashah">
        <div>
          <sheet-table
            :sheets="sheets[parashah]"
            :title="parashah"
          ></sheet-table>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Tabs from "./Tabs";
import SheetTable from "./SheetTable";

export default {
  data() {
    return {
      sheets: {},
      parashahs: [],
    };
  },
  components: {
    Tabs,
    SheetTable,
  },
  methods: {
    async onTabChange(sefer) {
      const res = await this.$axios.get("/api/sheets/" + sefer);
      this.sheets = res.data.sheets;
      this.parashahs = Object.keys(this.sheets);
    },
  },
};
</script>
